<template>
    <div class="animated fadeIn">
        <CForm
                ref="form"
                v-if="dataFormStructures.limitedSubscription.rows !== undefined"
                :structure="dataFormStructures.limitedSubscription">
            <template v-for="row, rowIndex in dataFormStructures.limitedSubscription.rows">
                <template v-for="col, colIndex in row.cols">
                    <template :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                        <slot v-for="card in col.cards" v-if="card.key !== ''" :slot="card.key">
                            <slot :name="card.key"></slot>
                        </slot>
                    </template>
                </template>
            </template>
        </CForm>
        <ModalConfirm
                @onConfirm="replaceExpirationDate"
                :closeOnConfirm="true"
                :caption="Core.Definition.getDefinition('Date d\'expiration')"
                ref="modalConfirmReplaceExpirationDate">
            <slot slot="body">
                {{Core.Definition.getDefinition('Voulez-vous remplacer la date d\'expiration de cet abonnement par la nouvelle date d\'expiration calculée à partir des informations du produit sélectionné?')}}
            </slot>
        </ModalConfirm>
    </div>
</template>

<script>
    var _self;
    import CForm from '../components/CForm'
    import ModalConfirm from '../components/ModalConfirm'
    export default {
        name: 'FormLimitedSubscription',
        components: {
            CForm,
            ModalConfirm
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataProduct: {
                    expirationPeriod: '',
                    expirationPeriodLength: '',
                    id: ''
                },
                dataFieldRefs: [],
                dataId: '',
                dataFormStructures: {
                    limitedSubscription: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Abonnement limité'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'expirationDate'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'productLimitedSubscriptionSummary'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'bookingSummary'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'status',
                                type: 'select',
                                label: Core.Definition.getDefinition('État'),
                                value: Core.Select.select(Mantle.Subscription.statusActivated, Mantle.Subscription.statusOptions()),
                                onSelect: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'expirationDate',
                                type: 'datePicker',
                                isInline: false,
                                description: Core.Definition.getDefinition('Ignoré si vide. Après cette date, l\'abonnement sera complété.'),
                                label: Core.Definition.getDefinition('Date d\'expiration'),
                                value: null,
                                onChange: function() {}
                            },
                            {
                                id: 'notes',
                                type: 'notes'
                            },
                            {
                                id: 'productLimitedSubscriptionSummary',
                                type: 'productLimitedSubscriptionSummary',
                                value: [],
                                updateTotal: function(subTotal, total, form, fieldRefs) {
                                    _self.dataFieldRefs = fieldRefs
                                    _self.$emit('onUpdateTotal', subTotal, total)
                                },
                                onChange: function(products, form, fieldRefs) {
                                    _self.dataFieldRefs = fieldRefs
                                    if (products !== null && products[0] !== undefined) {
                                        fieldRefs['bookingSummary'].dataBookingLimit = products[0].quantity
                                        let product = products[0].instance
                                        if (product.id !== _self.dataProduct.id) {
                                            _self.dataProduct = product
                                            if (!isNaN(product.expirationPeriodLength) && product.expirationPeriodLength > 0) {
                                                let currentExpirationDate = fieldRefs['expirationDate'].dataValue
                                                if (currentExpirationDate === null) {
                                                    _self.replaceExpirationDate()
                                                } else {
                                                    let expirationDate = new Date(Core.Date.calc(product.expirationPeriod, product.expirationPeriodLength, 'YYYY-MM-DD'))
                                                    if (currentExpirationDate.getDate() !== expirationDate.getDate()) {
                                                        _self.$refs.modalConfirmReplaceExpirationDate.open = true
                                                    }
                                                }
                                            } else {
                                                //_self.$refs.modalConfirmReplaceExpirationDate.open = true
                                            }
                                        }
                                    }
                                }
                            },
                            {
                                id: 'bookingSummary',
                                type: 'bookingSummary',
                                value: []
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            replaceExpirationDate() {
                this.dataFieldRefs['expirationDate'].dataValue = null
                if (this.dataProduct.expirationPeriod !== undefined && this.dataProduct.expirationPeriod !== '') {
                    if (this.dataProduct.expirationPeriodLength !== undefined && !isNaN(this.dataProduct.expirationPeriodLength) && this.dataProduct.expirationPeriodLength > 0) {
                        let expirationDate = Core.Date.calc(this.dataProduct.expirationPeriod, this.dataProduct.expirationPeriodLength)
                        this.dataFieldRefs['expirationDate'].dataValue = new Date(expirationDate)
                    }
                }
            }
        }
    }
</script>
